import { CreateOrderRequest } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export function copy(
    state: WritableDraft<CreateOrderRequest>,
    payload: PayloadAction<CreateOrderRequest>,
) {
    Object.assign(state, payload.payload);
    state.discounts = [];
    state.totalDiscount = 0;
    state.totalCouponDiscount = 0;
    state.totalPointDiscount = 0;
    state.totalGiftDiscount = 0;
}
